module.exports = __webpack_public_path__ + "img/twitter.4809b915.svg";